import * as React from 'react';
import { connect } from 'react-redux';
import { useDrag } from 'react-dnd';

// Global Actions
import { updateHarvestEventTimeline } from 'services/harvestEvents/actions';

// Constants
import { EVENT_TABLE_ROW } from '../../../../../../../../constants';

interface Props {
    harvestEventUuid: number;
    onClick: Function;
    children: React.Node;
    connectDragPreview: Function;
    className?: string;
    updateHarvestEventTimeline: Function;
}

export const EventTableRowDragSourceComponent = (props: Props) => {
    const { harvestEventUuid, onClick, children, className, ...rest } = props;

    const [{ isDragging }, drag] = useDrag({
        type: EVENT_TABLE_ROW,
        item: { id: harvestEventUuid },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                const { nextGroupId, date } = dropResult;
                rest.updateHarvestEventTimeline(
                    item.id,
                    undefined,
                    nextGroupId,
                    date
                );
            }
        },
        collect: monitor => ({
            isDragging: monitor.isDragging()
        })
    });

    return (
        <tr
            ref={drag}
            onClick={onClick}
            style={{
                opacity: isDragging ? 0.5 : 1
            }}
            className={className}
        >
            {children}
        </tr>
    );
};

export default connect(
    null,
    { updateHarvestEventTimeline }
)(EventTableRowDragSourceComponent);
